<template>
  <v-dialog
    v-model="dialog_params.show"
    scrollable
    max-width="1200px"
    :width="dialog_params.size"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          :color="
            dialog_params.type === 'error' || dialog_params.type === 'delete'
              ? '#EB6363'
              : '#17A2B8'
          "
          dark
          elevation="0"
        >
          <v-toolbar-title>{{ dialog_params.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              text
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text
        v-if="dialog_params.text"
        style="background-color: #dce3e7"
        class="pt-2"
      >
        <v-container>
          <slot name="body"> Carregando conteúdo </slot>
        </v-container>
      </v-card-text>

      <v-card-actions style="border-top: solid #d9d9d9 1px">
        <v-spacer></v-spacer>
        <slot name="buttons">
          <v-btn
            class="btn-limpa-filtro text-capitalize"
            @click="close()"
            >Fechar</v-btn
          >
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    dialog_params: {
      type: Object,
      default: { title: "Modal", size: "80%", show: false, type: null },
    },
  },
  methods: {
    close: function () {
      this.dialog_params.show = false;
    },
  },
};
</script>
